import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { WEEKDAY_KEY } from "../constants";

/**
 * Confirms removal of a staff member's lunch on the current weekday.
 * `lunchDelete` is the target staff id (or null when the dialog is closed).
 */
export default function DeleteLunchDialog({ lunchDelete, staffList, date, onConfirm, onClose }) {
  return (
    <AlertDialog open={!!lunchDelete} onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="lunch-delete-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete lunch?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to remove {staffList.find((s) => s.id === lunchDelete)?.full_name || "this staff member"}&apos;s lunch on {WEEKDAY_KEY[date.getDay()].toUpperCase()}?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="lunch-delete-no">No</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} data-testid="lunch-delete-yes">Yes, delete</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
